import { useDispatch } from "react-redux"
import { bookingOpen } from "../../../actions/booking.action"

const Section1 = () => {
  const dispatch:any = useDispatch()
  
  const handleOpenResa = () => {
    dispatch(bookingOpen(true))
  }
  return (
    <div className="component-section-1-home">
      <img src="/assets/images/background-section-1-home.png" alt="le blr" className="background-section-1-home" />
      <div className="container-section-1-home">
        <div className="title-first">LE BLR</div>
        <div className="subtitle">RESTAURANT</div>
        <div className="subtitle">LOUNGE BAR</div>
        <div className="button" onClick={()=> handleOpenResa()}>RESERVATION</div>     
      </div>
    </div>
  )
}

export default Section1